import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import {
  createForemanClientsToSiteMappings,
  deleteForemanClientsToSiteMappings,
  getForemanClientsToSiteMappings,
} from '@/services/core/foreman-site-mappings'
import type { IForemanClientsToSiteMappingForm } from '@/types/core/forms'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

export const useForemanClientsToSiteMappings = () => {
  const client = useQueryClient()

  const getMappingsQuery = () =>
    useQuery({
      queryKey: ['foreman-clients-to-site-mapping'],
      queryFn: () => getForemanClientsToSiteMappings(),
    })

  const createMappingMutation = useMutation({
    mutationFn: (form: IForemanClientsToSiteMappingForm) => createForemanClientsToSiteMappings(form),
    onError: NotifyErrorWrapper('Failed to create mapping'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['foreman-clients-to-site-mapping'] })
      NotifySuccess(`Mapping created successfully`)
    },
  })

  const deleteMappingMutation = useMutation({
    mutationFn: (id: number) => deleteForemanClientsToSiteMappings(id),
    onError: NotifyErrorWrapper('Failed to delete mapping'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['foreman-clients-to-site-mapping'] })
      NotifySuccess(`Mapping deleted successfully`)
    },
  })

  return {
    getMappingsQuery,
    createMappingMutation,
    deleteMappingMutation,
  }
}
